const PasswordUpdateMode = {
  Create: 'create',
  Reset: 'reset',
};

export { PasswordUpdateMode };
